import {IVideo, Video} from 'app/blocks/model/video.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class VideoService extends EntityCrudService<IVideo> {
    constructor(http: HttpClient) {
        super(http, Resource.VIDEOS, (obj?) => new Video(obj));
    }

    getVideoDeliveryUrl(videoId: number): Observable<string> {
        return this.http.get<string>(`${this._resourceUrl}/${videoId}/delivery-url`);
    }
}
